import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import api from '../utils/api';

export const useRankings = (currentUserId) => {
  return useQuery({
    queryKey: ['rankings', currentUserId],
    queryFn: async () => {
      const { data } = await api.get('/dashboard/rankings');
      return data.rankings; // backend will return full array with isCurrentUser flag
    },
    // Rankings don't need second-by-second freshness — this was polling
    // every 45s PLUS refetching on every window focus with no staleTime
    // gate, so any tutor/centre who left their dashboard tab open all day
    // generated a steady drip of requests around the clock. Bandwidth
    // investigation (Oct 2026) traced a meaningful chunk of ongoing API
    // traffic to this. 3 minutes is still "feels live" without the churn.
    staleTime: 60 * 1000,
    refetchInterval: 3 * 60 * 1000,
    refetchOnWindowFocus: true,
    enabled: !!currentUserId,
  });
};